import '../css/custom.scss'; // importa il CSS custom qui!
// Importa moduli custom
import './components/statusbar.js';
import './components/megamenu.js';
import './components/category-slider.js';
import './components/category-subcategories-slider.js';
import './components/mobile-megamenu.js';
import './components/mobile-menu-interceptor.js';
import './components/mobile-categories-slider.js';
import './components/mobile-menu-vertical-arrows.js';
// import './components/emailsubscription.js';
import './components/review-slider.js';
import './components/product-cover.js';
import './components/product-other-tab.js';
// import './components/settori-height.js';
import './components/product-cross-selling.js';
import './components/live-chat.js';
import './components/modal-contact-form.js';
import './components/dynamic-colors.js';
import './components/product-sticky-block.js';
import './components/featured-categories-horizontal-scroll.js';
import './components/homepage-animation.js';
import './components/settori-slider.js';
import './components/category-names-formatter.js';
import './components/fix-variants.js';
import './components/footer-h3-converter.js';
import './components/fix-variants-loading.js';
import './components/fix-product-labels.js';
import './components/category-filter.js';
import './components/mobile-contact-bar.js';
import './components/category-scroll-to-top.js';